import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cx from 'classnames';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import { convertUrl } from '~/services/util';

const ForumItem = ({ creator, forumType, name, avatar, stats, comments, type, onClick }) => {
    const userID = useSelector((state) => state.app.user?.community_user_id);
    const url = convertUrl(avatar, '/images/default.png');

    return (
        <div className="vendor-search-forums-item" onClick={onClick}>
            <Row className="mx-0 d-flex ssm-column">
                <Col className="px-0 d-flex ai-center" sm={1} xs={12}>
                    <Avatar name={creator} url={url} />
                    <p className={`dsl-b16 mb-1 ms-0 ssm-l-3 truncate-one mobile-screen ${type === 'detail' && 'text-600'}`}>{name}</p>
                </Col>
                <Col className="px-0 py-2" sm={8} xs={12}>
                    <p className={`dsl-b16 mb-1 truncate-one desktop-screen ${type === 'detail' && 'text-600'}`}>{name}</p>
                    <p className="dsl-b14 mb-1">Created by: {creator}</p>
                </Col>
                <Col className="px-0 d-flex flex-column ai-end" sm={3} xs={12}>
                    <p className="dsl-m12 mb-2">{forumType}</p>
                    <div className="d-h-end">
                        <Icon name="far fa-eye" size={12} />
                        <p className="dsl-m12 mb-0 ms-1 me-4">{stats?.views || 0}</p>
                        <Icon name="far fa-thumbs-up" size={12} color={stats?.liked && userID && stats?.liked[userID] ? '#376caf' : '#969faa'} />
                        <p className={cx('dsl-m12 mb-0 ms-1 me-4', stats?.liked && userID && stats?.liked[userID] && 'dsl-p12 text-400')}>{stats?.likes || 0}</p>
                        <Icon name="far fa-comment" size={12} color={comments.some((comment) => comment.user_id === userID) ? '#376caf' : '#969faa'} />
                        <p className={cx('dsl-m12 mb-0 ms-1', comments.some((comment) => comment.user_id === userID) && 'dsl-p12 text-400')}>{stats?.comments || 0}</p>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

ForumItem.propTypes = {
    avatar: PropTypes.string,
    creator: PropTypes.string,
    forumType: PropTypes.string,
    name: PropTypes.string,
    stats: PropTypes.shape({
        comments: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dislikes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        like_avg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        likes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        views: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    type: PropTypes.oneOf(['simple', 'detail']),
    onClick: PropTypes.func,
};

ForumItem.defaultProps = {
    avatar: null,
    creator: 'Alexa Rainman',
    forumType: 'Finance & Insurance',
    name: '',
    stats: {
        comments: '',
        dislikes: 0,
        like_avg: '0',
        likes: '0',
        views: 453,
    },
    type: 'simple',
    onClick: () => {},
};

export default memo(ForumItem);
